import {Sensor} from "../sensor/sensor";
import {Nodo} from "../nodo/nodo";
import { Sucursal } from "../sucursal/sucursal";

export class Ubicacion{
	_id: string;
	descripcion: string;
	area: string;
	estado: boolean;
	sucursal_id: any;
	sensores: Sensor[];
	nodos : Nodo[];
	alarmaActiva: boolean;
	enviaSms: boolean;
	color: String;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/ubicacion/ubicacion.ts